// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.standard-msg[data-v-79839a84] {\n  color: red;\n  font-size: 1.15em;\n  padding-bottom: 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
